window.productMainJs = window.productMainJs || {
  isInitialized: false,
  resizeHandler: function () {
    const productMainArea = document.querySelector('.arjo-m-product-main-area');
    const productMainAreaContainer = productMainArea.querySelector('.arjo-m-product-main-area__container');
    if (!productMainAreaContainer) {
      return;
    }
    const header = productMainAreaContainer.querySelector('.arjo-m-product-main-area__header');
    const sectionLinks = productMainAreaContainer.querySelector('.arjo-m-product-main-area__section-links');
    const helpLinks = productMainAreaContainer.querySelector('.arjo-m-product-main-area__helps');
    const carouselContainer = productMainAreaContainer.querySelector('.arjo-m-product-main-area__carousel-container');
    const carousel = carouselContainer.querySelector('.arjo-o-carousel');
    const sections = productMainAreaContainer.querySelector('.arjo-m-product-main-area__sections');
    const productAddddToCart = productMainAreaContainer.querySelector('.arjo-m-eshop-product-add-to-cart');

    let pageHeaderBottom = 0;
    const pageHeader = document.querySelector('nav.arjo-o-header');
    if (pageHeader) {
      var pageHeaderRect = pageHeader.getBoundingClientRect();
      pageHeaderBottom = Math.max(0, Math.floor(pageHeaderRect.bottom));
      productMainArea.style.setProperty('--page-header-bottom', pageHeaderBottom + 'px');
    }

    if (carouselContainer && !carousel) {
      carouselContainer.style.paddingBottom = 0;
    }

    const sectionLinksHeight = sectionLinks?.getBoundingClientRect()?.height ?? 0;

    if (window.arjoJs.isDesktop()) {
      const mainAreaRect = productMainAreaContainer.getBoundingClientRect();
      const headerInner = header?.querySelector('.arjo-m-product-main-area__header-container');
      /* For tablet and desktop */
      const headerInnerHeight = headerInner?.getBoundingClientRect()?.height ?? 0;
      const helpLinksHeight = helpLinks?.getBoundingClientRect()?.height ?? 0;
      const carouselHeight = carousel?.getBoundingClientRect()?.height ?? 0;
      const productAddddToCartHeight = productAddddToCart?.getBoundingClientRect()?.height ?? 0;

      productMainArea.style.setProperty('--section-link-height', '0px');

      const leftHeight = headerInnerHeight + sectionLinksHeight + helpLinksHeight;

      const start = Math.max(0, mainAreaRect.y);
      const end = Math.max(0, window.innerHeight - mainAreaRect.bottom);
      const availableHeight = window.innerHeight - start - end;

      const stickyPosition = Math.min(0, availableHeight - leftHeight);

      header.style.position = 'sticky';
      header.style.top = pageHeaderBottom + stickyPosition + 'px';
      header.style.marginBottom = sectionLinksHeight + helpLinksHeight + productAddddToCartHeight + 'px';

      sectionLinks.style.position = 'sticky';
      sectionLinks.style.top = pageHeaderBottom + stickyPosition + headerInnerHeight + productAddddToCartHeight + 'px';
      sectionLinks.style.marginTop = headerInnerHeight + productAddddToCartHeight + 'px';
      sectionLinks.style.marginBottom = helpLinksHeight + 'px';

      if (productAddddToCart) {
        productAddddToCart.style.position = 'sticky';
        productAddddToCart.style.top = pageHeaderBottom + stickyPosition + headerInnerHeight + 'px';
        productAddddToCart.style.marginTop = headerInnerHeight + 'px';
        productAddddToCart.style.marginBottom = helpLinksHeight + sectionLinksHeight + 'px';
      }

      helpLinks.style.position = 'sticky';
      helpLinks.style.top = pageHeaderBottom + stickyPosition + headerInnerHeight + sectionLinksHeight + productAddddToCartHeight + 'px';
      helpLinks.style.marginTop = headerInnerHeight + sectionLinksHeight + productAddddToCartHeight + 'px';

      sections.style.marginTop = carouselHeight + 'px';
      sections.style.display = 'block';
      sectionLinks.style.opacity = 1;
      helpLinks.style.opacity = 1;
      productAddddToCart && (productAddddToCart.style.opacity = 1);
    } else {
      productMainArea.style.setProperty('--section-link-height', sectionLinksHeight + 'px');

      header.style.removeProperty('position');
      header.style.removeProperty('top');
      header.style.removeProperty('margin-top');
      header.style.removeProperty('margin-bottom');

      sectionLinks.style.removeProperty('position');
      sectionLinks.style.removeProperty('top');
      sectionLinks.style.removeProperty('margin-top');
      sectionLinks.style.removeProperty('margin-bottom');

      productAddddToCart?.style.removeProperty('position');
      productAddddToCart?.style.removeProperty('top');
      productAddddToCart?.style.removeProperty('margin-top');
      productAddddToCart?.style.removeProperty('margin-bottom');

      helpLinks.style.removeProperty('position');
      helpLinks.style.removeProperty('top');
      helpLinks.style.removeProperty('margin-top');
      helpLinks.style.removeProperty('margin-bottom');

      sections.style.removeProperty('margin-top');
      sections.style.removeProperty('display');

      productMainAreaContainer.style.removeProperty('grid-template-rows');

      sectionLinks.style.top = pageHeaderBottom + 'px';
    }
  },
  setupSectionLinks: function () {
    const productMainArea = document.querySelector('.arjo-m-product-main-area__container');
    var sectionLinks = document.querySelector('.arjo-m-product-main-area__section-links');
    if (!sectionLinks) {
      return;
    }

    var linkList = sectionLinks.querySelector('.arjo-m-product-main-area__section-links-container');
    if (!linkList) {
      return;
    }

    /* For mobile part */
    var sectionLinksHeader = sectionLinks.querySelector('.arjo-m-product-main-area__section-links-header');
    if (!sectionLinksHeader) {
      return;
    }

    var sectionLinksHeaderText = sectionLinksHeader.querySelector('.arjo-m-product-main-area__section-links-header-text');
    if (!sectionLinksHeaderText) {
      return;
    }

    var sectionLinksHeaderIcon = sectionLinksHeader.querySelector('.arjo-m-product-main-area__section-links-header .arjo-a-icon');
    if (!sectionLinksHeaderIcon) {
      return;
    }
    /* End for mobile part */

    var links = [...linkList.querySelectorAll('.arjo-a-link[data-arjo-section]')];
    links.forEach((link) => {
      if (link.hasAttribute('data-arjo-active')) {
        link.removeAttribute('data-arjo-active');
        link.closest('li').setAttribute('data-arjo-active', 'true');
      }
      link.addEventListener('click', (e) => {
        e.preventDefault();

        var href = link.getAttribute('data-arjo-section');
        if (!href || !href.startsWith('#')) {
          return;
        }

        var target = productMainArea.querySelector(href);
        if (!target) {
          return;
        }

        var sections = [...productMainArea.querySelectorAll('.arjo-m-product-main-area__section')];
        sections.forEach((section) => {
          section.style.display = 'none';
        });

        target.style.display = 'block';
        sectionLinksHeaderText.textContent = link.textContent;
        this.resizeHandler();

        linkList.removeAttribute('data-arjo-expand');
        sectionLinksHeaderIcon.removeAttribute('data-arjo-expand');

        links.forEach((l) => {
          l.closest('li').removeAttribute('data-arjo-active');
        });
        link.closest('li').setAttribute('data-arjo-active', 'true');

        const pageHeader = document.querySelector('nav.arjo-o-header');
        if (pageHeader?.classList.contains('sticky')) {
          document.querySelector('.arjo-m-product-main-area__sections').scrollIntoViewEx(0, [sectionLinksHeader]);
        }

        return false;
      });
    });

    if (links.length) {
      sectionLinksHeaderText.textContent = links[0].textContent;
    }

    sectionLinksHeader.addEventListener('click', () => {
      linkList.toggleAttribute('data-arjo-expand');
      sectionLinksHeaderIcon.toggleAttribute('data-arjo-expand');
    });

    document.addEventListener('click', function (e) {
      if (!sectionLinks.contains(e.target)) {
        linkList.removeAttribute('data-arjo-expand');
        sectionLinksHeaderIcon.removeAttribute('data-arjo-expand');
      }
    });
  },
  setupAnchorLinks: function () {
    const productMainArea = document.querySelector('.arjo-m-product-main-area__container');
    if (!productMainArea) {
      return;
    }

    var helps = productMainArea.querySelector('.arjo-m-product-main-area__helps');
    if (!helps) {
      return;
    }

    var anchorLinks = [...helps.querySelectorAll('.arjo-a-link-with-icon[data-arjo-tab]')];
    anchorLinks.forEach((anchorLink) => {
      anchorLink.addEventListener('click', (e) => {
        e.preventDefault();
        var tabName = anchorLink.getAttribute('data-arjo-tab');
        if (!tabName) {
          return;
        }

        var tab = document.querySelector('label[for="' + tabName + '"]');
        if (!tab) {
          return;
        }

        tab.click();

        var tabContainer = tab.closest('.arjo-o-tab-container');
        if (tabContainer) {
          tabContainer.scrollIntoViewEx();
        } else {
          tab.scrollIntoViewEx();
        }

        return false;
      });
    });
  },
  init: function () {
    let _this = window.productMainJs;
    if (_this.isInitialized) {
      return;
    }
    _this.isInitialized = true;

    _this.setupSectionLinks();
    _this.setupAnchorLinks();

    addEventListener('resize', _this.resizeHandler);
    addEventListener('scroll', _this.resizeHandler);

    if ('ResizeObserver' in window) {
      // create an Observer instance
      const resizeObserver = new ResizeObserver((entries) => _this.resizeHandler());

      // start observing a DOM node
      resizeObserver.observe(document.body);

      const header = document.querySelector('nav.arjo-o-header');
      if (header) {
        resizeObserver.observe(header);
      }
    }

    _this.resizeHandler();
  },
};

window.productMainJs.init();
